import React, { useEffect, useState } from "react";
import DateEnableSwitch from "../molecules/dateSelector/DateEnableSwitch";
import FromToDatePickers from "../molecules/dateSelector/FromToDatePickers";
import classes from "./UpdateDateFilter.module.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../../states/userState";

const UpdateDateFilter = () => {
  const user = useRecoilValue(userState);
  const [checked, setChecked] = useState(user.filters.isUpdateEnable);
  const getEndOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };
  const getStartOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() - 0, 1);
  };
  const today = new Date();
  const initialStartDate =
    !user.filters.fromDate || user.filters.drawingUpdFrm === ""
      ? getStartOfMonth(today)
      : new Date(user.filters.drawingUpdFrm);
  const initialEndDate =
    !user.filters.toDate || user.filters.drawingUpdTo === ""
      ? getEndOfMonth(today)
      : new Date(user.filters.drawingUpdTo);
  console.log("Date", initialEndDate, initialStartDate);
  const [fromDate, setFromdate] = useState(initialStartDate);
  const [toDate, setTodate] = useState(initialEndDate);
  useEffect(() => {
    console.log("checked", checked);
    if (checked == true) {
      setFromdate(initialStartDate);
      setTodate(initialEndDate);
    }
  }, [checked]);

  return (
    <div className={classes.container}>
      <div className={classes.selectGroup}>
        <div className={classes.switch}>
          <DateEnableSwitch checked={checked} setChecked={setChecked} />
        </div>
      </div>
      <div className={classes.dateGroup}>
        <div className={classes.datePicker}>
          <FromToDatePickers
            disabled={!checked}
            setFromdate={setFromdate}
            setTodate={setTodate}
            fromDate={fromDate}
            toDate={toDate}
            mode="flex"
            label={""}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateDateFilter;
